import { useEffect, useCallback, useState, Fragment } from 'react';

// eslint-disable-next-line jira/wrm/no-load-bridge
import { waitForHeritage } from '@atlassian/jira-common-bridge/src';
// eslint-disable-next-line jira/wrm/no-load-bridge
import { jiraSuperBatchDependencies } from '@atlassian/jira-common-bridge/src/constants';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import { asyncWrmRequire } from '../async-wrm.tsx';
import { getJiraHeritageDependencies } from './constants.tsx';
import { useWrmStatsEffects } from './controllers/wrm-stats/index.tsx';

const JiraHeritageLoaderOld = () => {
	const route = useCurrentRoute();
	const [{ isReady }] = useSpaStatePageReady();
	const [hasHeritageDownloaded, setHasHeritageDownloaded] = useState(false);

	useWrmStatsEffects();

	/* eslint-disable jira/wrm/no-load-bridge */
	const loadJiraHeritageDependencies = useCallback(() => {
		setHasHeritageDownloaded(true);
		asyncWrmRequire([
			...jiraSuperBatchDependencies,
			...getJiraHeritageDependencies(),
			// @ts-expect-error - TS2339 - Property 'resolve' does not exist on type 'Promise<undefined> | Deferred<undefined>'.
		]).then(() => waitForHeritage()?.resolve?.());
	}, []);

	useEffect(() => {
		if (isReady && !hasHeritageDownloaded) {
			loadJiraHeritageDependencies();
		}
	}, [hasHeritageDownloaded, isReady, loadJiraHeritageDependencies, route]);

	return null;
};

const JiraHeritageLoaderNew = Fragment;

const JiraHeritageLoader = componentWithCondition(
	() => fg('no-wrm-heritage-loader'),
	JiraHeritageLoaderNew,
	JiraHeritageLoaderOld,
);

JiraHeritageLoader.displayName = 'JiraHeritageLoader';

export { JiraHeritageLoader };
